import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
// import WalletPrograms from '../../../WalletPrograms';
import Login from '../../../Login';
import { HOME_ROUTE, LANDING_ROUTE } from '../../../../constants/routes';
import NotFound from '../NotFound';
import { DashboardWrapper } from '../../styles';

const RootComponent = ({
  isLoggedIn,
  // verified
}) => {
  return (
    <Switch>
      <Route
        exact
        path={LANDING_ROUTE}
        render={props => {
          if (isLoggedIn) {
            return (
              // verified ?
              <Redirect to={HOME_ROUTE} />
            );
            // : (
            //   <Redirect to={{ pathname: ONBOARDING_ROUTE }} />
            // );
          }
          return <Login {...props} />;
        }}
      />
      <Route
        render={() => {
          return (
            <DashboardWrapper>
              <NotFound />
            </DashboardWrapper>
          );
        }}
      />
    </Switch>
  );
};

RootComponent.propTypes = {
  verified: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
};

RootComponent.defaultProps = {
  verified: false,
  isLoggedIn: false,
};

export default RootComponent;
